import { render, staticRenderFns } from "./DeviceCard.vue?vue&type=template&id=3917f6a4&scoped=true&"
import script from "./DeviceCard.vue?vue&type=script&lang=ts&"
export * from "./DeviceCard.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceCard.vue?vue&type=style&index=0&id=3917f6a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3917f6a4",
  null
  
)

export default component.exports